import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingFlow,
  UpdateMarketingFlowPayload
} from "../../marketing.types";
import { requestUpdateMarketingFlow } from "./updateMarketingFlow.request";

const useUpdateMarketingFlow = (
  options?: MutationOptions<
    MarketingFlow,
    ApiServiceError<ApiError>,
    UpdateMarketingFlowPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateMarketingFlow,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateMarketingFlow;
